const DEBUG_STORAGE_KEY = 'fms:catalog-cross-tab-debug'

const TAB_ID = (() => {
  try {
    let id = sessionStorage.getItem('fms:catalog-tab-id')
    if (!id) {
      id = Math.random().toString(36).slice(2, 8)
      sessionStorage.setItem('fms:catalog-tab-id', id)
    }
    return id
  } catch {
    return 'unknown'
  }
})()

export function getCatalogCrossTabTabId(): string {
  return TAB_ID
}

export function isCatalogCrossTabDebugEnabled(): boolean {
  try {
    return localStorage.getItem(DEBUG_STORAGE_KEY) === '1'
  } catch {
    return false
  }
}

export function catalogCrossTabLog(event: string, detail?: Record<string, unknown>): void {
  if (!isCatalogCrossTabDebugEnabled()) {
    return
  }
  console.debug(`[catalog-cross-tab][tab:${TAB_ID}]`, event, { ts: Date.now(), ...detail })
}

/** Structured UI snapshot — call from render hooks when derived state changes. */
export function catalogCrossTabLogUiState(source: string, state: Record<string, unknown>): void {
  catalogCrossTabLog(`ui:${source}`, state)
}

/** Enable in DevTools: localStorage.setItem('fms:catalog-cross-tab-debug', '1') */
export function enableCatalogCrossTabDebug(): void {
  try {
    localStorage.setItem(DEBUG_STORAGE_KEY, '1')
    console.info(
      `[catalog-cross-tab][tab:${TAB_ID}] debug enabled — reload optional; filter console by "catalog-cross-tab"`
    )
  } catch {
    // ignore
  }
}
